import type * as React from "react";

/** One icon button in a {@link HoverActionToolbar}. */
export interface HoverAction {
  /** React list key; distinct per action within one toolbar. */
  key: string;
  icon: React.ReactNode;
  /** Tooltip text, and the button's accessible name. */
  tooltip: string;
  onClick: () => void;
  /** Renders the button greyed and inert; the tooltip still explains why. */
  disabled?: boolean;
}

/**
 * Drops the actions a caller does not have, so an optional action can be
 * assembled inline: `hoverActions(visualize, jump, setAnchorAction)`.
 */
export function hoverActions(
  ...actions: readonly (HoverAction | undefined)[]
): HoverAction[] {
  return actions.filter((action) => action !== undefined);
}
